import React, { Component } from "react";
import { Scrollbars } from "react-custom-scrollbars";

class FilterPanel extends Component {
	state = {
		atBottom: false
	};

	componentDidMount() {
		document.addEventListener("mousedown", this.toggleFunction);
	}

	componentWillUnmount() {
		document.removeEventListener("mousedown", this.toggleFunction);
	}

	toggleFunction = (event) => {
		const { show, toggle } = this.props;
		if (this.filterWrap && !this.filterWrap.contains(event.target) && show) {
			toggle();
		}
	};

	handleScrollFrame = (e) => {
		const { atBottom } = this.state;
		const { toggleAtBottom } = this.props;
		if (toggleAtBottom) {
			if (atBottom && e.top !== 1) {
				toggleAtBottom(false);
			}
			if (!atBottom && e.top === 1) {
				toggleAtBottom(true);
			}
		}
	};

	render() {
		const { show, toggle, title, closeBtn, children, className = "" } = this.props;
		return (
			<div className={`filter-wrap ${className} ${show ? "show" : ""}`} ref={(event) => (this.filterWrap = event)}>
				<Scrollbars autoHide className="wrapper-scrollbar" onScrollFrame={this.handleScrollFrame}>
					<div className="filter-container">
						<div className={`filter-header ${!title ? "no-title" : ""}`}>
							{title ? <h4 className="filter-title">{title}</h4> : null}
							{closeBtn ? (
								<div className="filter-close" onClick={() => toggle()}>
									<i className="icon icon-close" />
								</div>
							) : null}
						</div>
						{children}
					</div>
				</Scrollbars>
			</div>
		);
	}
}

export default FilterPanel;

export const PanelBody = ({ className, children }) => (
	<div className={`filter-body ${className ? className : ""}`}>{children ? children : null}</div>
);
export const PanelFooter = ({ className, children }) => (
	<div className={`filter-footer ${className ? className : ""}`}>{children ? children : null}</div>
);
